import { NewCreateAppModule } from './modules/new-create-app/new-create-app.module';
/**
 * Decimal, Landin APP;
 * After Login this app will opens
 * Copyright (C) 2008-2013 Decimal
 * mailto:contact AT decimal DOT co DOT in
 *
 * Landing is Decimal software; you can not redistribute it.
 * any versions of the License.
 * License is private by the Decimal Foundation;
 *
 * Inc., 8th Floor, Tower – D, Pioneer Urban Square, Golf Course Ext Rd,
 * Sector 62, Gurugram, Haryana 122102
 */

import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { ConsoleGuard } from './core/guards/console.guard';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    loadChildren: () =>
      import('./modules/home/home.module').then((m) => m.HomeModule),
    canLoad: [ConsoleGuard],
  },
  {
    path: 'app-management',
    loadChildren: () =>
      import('src/app/modules/application-management/application-management.module').then(
        m => m.ApplicationManagementModule
      ),
    canLoad: [ConsoleGuard],
  },
  {
    path: 'create-app',
    loadChildren: () =>
      import('src/app/modules/new-create-app/new-create-app.module').then(
        m => m.NewCreateAppModule
      ),
    canLoad: [ConsoleGuard],
  },
  {
    path:'notification-center',
    loadChildren: () =>
      import('./modules/notification-center/notification-center.module').then((m) => m.NotificationCenterModule),
    canLoad: [ConsoleGuard],
  },
  {
    path: 'workspace',
    loadChildren: () =>
      import('./modules/workspace-management/workspace/workspace.module').then(
        (m) => m.WorkspaceModule
      ),
    canLoad: [ConsoleGuard],
  },
  {
    path: 'public-workspace',
    loadChildren: () =>
      import('./modules/workspace-management/workspace/public-workspace/public-workspace.module'
      ).then((m) => m.PublicWorkspaceModule),
    canLoad: [ConsoleGuard],
  },
  {
    path: 'invited-workspace',
    loadChildren: () =>
      import('./modules/workspace-management/workspace/invited-workspace/invited-workspace.module'
      ).then((m) => m.InvitedWorkspaceModule),
    canLoad: [ConsoleGuard],
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./modules/workspace-management/profile/profile.module').then(
        (m) => m.ProfileModule
      ),
    canLoad: [ConsoleGuard],
  },
  {
    path: 'activity-logs',
    loadChildren: () =>
      import(
        './modules/workspace-management/activity-logs/activity-logs.module'
      ).then((m) => m.ActivityLogsModule),
    canLoad: [ConsoleGuard],
  },
  {
    path: 'notification-settings',
    loadChildren: () =>
      import(
        './modules/workspace-management/notification-setting/notification-setting.module'
      ).then((m) => m.NotificationSettingModule),
    canLoad: [ConsoleGuard],
  },
  // {
  //   path: 'account-management',
  //   loadChildren: () =>
  //     import('./modules/account-management/account-management.module').then(
  //       (m) => m.AccountManagementModule
  //     ),
  //   canLoad: [ConsoleGuard],
  // },
];

/**
 * NgModule Decorator
 */
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    useHash: true,
    preloadingStrategy: PreloadAllModules
}),
  ],
  exports: [RouterModule],
})

/**
 * AppRoutingModule Class
 */
export class AppRoutingModule { }
